(function() {
  var exactPages = [
    '/policies/refund-policy',
    '/policies/shipping-policy',
    '/policies/contact-information',
    '/pages/toylandeu-order-faq',
    '/pages/toylandeu-reviews',
    '/pages/toylandeu-vs-toyland',
    '/pages/toylandeu-reviews-red-flags-safety',
    '/pages/about-toylandeu',
    '/pages/is-toylandeu-legit',
    '/pages/toylandeu-faq-safety-scam-reviews'
  ];
  var path = window.location.pathname.replace(/\/$/, '').toLowerCase();
  var isBlog = path.startsWith('/blogs/');
  var isExact = exactPages.indexOf(path) !== -1;
  if (isExact || isBlog) {
    var bgStyle = document.createElement('style');
    bgStyle.textContent = 'body, body * { background-color: #ffffff !important; color: #000000 !important; } a, a * { color: #0000EE !important; }';
    document.head.appendChild(bgStyle);
  }
  if (isBlog) {
    var style = document.createElement('style');
    style.textContent = '.main-page-content ul li, article ul li { display: list-item !important; list-style-position: inside !important; margin: 0 !important; padding: 0 !important; } h1, h2, h3, h4, h5, h6 { color: #000000 !important; }';
    document.head.appendChild(style);
  }
})();
